export const enum CHANNEL {
    BCP_EXPERIENCE_IA = 'bcpexperiencia',
    BCP_EXPERIENCE_LANDING = 'bcpexperience',
    BCP_BANA = 'bcpbana',
    BCP = 'bcp',
    BCP_AUTOEFECTIVO = 'bcpautoefectivo',
    YAPE_AUTOEFECTIVO = 'yapeautoefectivo',
    FAST_QUOTE = 'bcpfastquote'
}